export default {
	state: {
		snackbar: {
			show: false,
			text: ''
		},
	},
	
	mutations: {
		showSnackbar(state, payload) {
			state.snackbar.text = payload
			state.snackbar.show = true
			window.setTimeout(() => {state.snackbar.show = false}, 4000)
		},

		hideSnackbar(state) {
			state.snackbar.show = false
		},
	},

	getters: {
		snackbar(state) {
			return state.snackbar
		},
	},

	actions: {
		showSnackbar({commit}, payload) {
			commit('showSnackbar', payload)
		},
	}
}